export default __webpack_public_path__ + "static/media/logo-standard.5b18e5d9.svg";